import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {TaskService} from '../../services/task.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {isArray} from 'util';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
@Component({
  selector: 'nf-pulse-integration',
  templateUrl: './pulse-integration.component.html',
  styleUrls: ['./pulse-integration.component.css'],
  providers: [TaskService]
})
export class PulseIntegrationComponent implements OnInit {
  dataSubscription: Subscription = null;
  boardId = null; // 存放面板ID
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  recipeId: string; // 模板ID
  relationId: string;
  fieldsData: Array<any> = []; // 存放映射列数据
  sourceFieldId: string; // 选中映射列的数据
  mappingConfig: any = {}; // 组装任务数据
  selectedLabels = [];
  dataId: string; // 外部请求参数
  dataSource: string; // 外部请求参数
  businessType: string; // 外部请求类别参数
  systemRoles = []; // 系统角色
  sourceRoleId: string; // 选中的角色ID
  sourceUserId: string; // 选择的人员ID
  systemUsers = []; // 系统人员
  searchChange$ = new BehaviorSubject('');
  isLoading = false;
  randomUserUrl: string;
  loadMoreData = true;
  pageIndex = 1;
  pageSize = 10;
  searchKey;
  getBoardUserList: Observable<any>;
  firstLoading = true;
  @Input('nfData') set changeData(data: any) {
    if (JSON.stringify(data) !== '{}') {
      this.boardData = data;
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
      this.boardId = this.boardData.id;
      this.boardColumnData.forEach((item, index) => {
        item.mappingFirstValue = '';
        item.mappingValue = [];
        item.mappingEndValue = '';
      });
      this.initMappingConfig();
    }
  }
  @Input('nfRecipeId') set changeId(id: any) {
    if (id) {
      this.recipeId = id;
    }
  }
  @Input('nfRelationId') set changeRelationId(id: any) {
    if (id) {
      this.relationId = id;
    }
  }
  @Input('dataId') set dataIdChange(dataId: any) {
    this.dataId = dataId;
  }
  @Input('dataSource') set dataSourceChange(dataSource: any) {
    this.dataSource = dataSource;
  }
  @Input('businessType') set businessTypeChange(businessType: any) {
    this.businessType = businessType;
  }
  @Input() columns = [];
  @Input('nfInstanceData') set ChangeInstanceData(data: any) {
    // 获取集成任务数据回填
    if (data) {
      const instanceData = data.mappingConfig;
      setTimeout(() => {
        this.boardColumnData.forEach((column, index) => {
          for (const item in instanceData) {
            if (instanceData.hasOwnProperty(item)) {
              if (column.id === item) {
                if (instanceData[item].mappingParts) {
                  this.boardColumnData[index].mappingFirstValue = instanceData[item].mappingParts[0].text;
                  this.boardColumnData[index].mappingEndValue = instanceData[item].mappingParts[instanceData[item].mappingParts.length - 1].text;
                  if (instanceData[item].mappingParts.length > 0) {
                    instanceData[item].mappingParts.forEach((m, n) => {
                      if (m.sourceField) {
                        this.boardColumnData[index].mappingValue.push(m.sourceField);
                      }
                    });
                  }
                } else {
                  if (instanceData[item].fixedValue.original) {
                    this.boardColumnData[index].mappingValue = instanceData[item].fixedValue.original;
                  }
                  if (instanceData[item].fixedValue.option) {
                    this.boardColumnData[index].mappingValue = instanceData[item].fixedValue.option;
                  }
                  if (instanceData[item].fixedValue.ids && instanceData[item].fixedValue.ids.length > 0) {
                    this.boardColumnData[index].mappingValue = instanceData[item].fixedValue.ids[0];
                  }
                }
              }
            }
          }
        });
      }, 500);
    }
  }
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService,
    private http: HttpClient,
    private message: NzMessageService
  ) { }

  ngOnInit() {
  }
  // 获取映射列数据
  getAutomationsBoundTypeMapData(column) {
    const param = {
      'relationId': this.relationId,
      'boardId': this.boardId,
      'columnId': column.id
    };
    const externalParam = {};
    if (this.dataId) {
      externalParam['dataId'] = this.dataId;
    }
    if (this.dataSource) {
      externalParam['dataSource'] = this.dataSource;
    }
    if (this.businessType) {
      externalParam['businessType'] = this.businessType;
    }
    this.dataSubscription = this.taskService.getAutomationsBoundTypeMap(param, externalParam).subscribe((res: any) => {
      if (res) {
        this.fieldsData = res;
        if (column.type === 'name' && this.columns && this.columns.length > 0) {
          for (const _column of this.columns) {
            this.fieldsData.push({
              id: _column.id,
              type: 'column',
              title: _column.title
            });
          }
        }
      }
    });
  }
  // 处理初始化mappingConfig
  initMappingConfig() {
    this.boardColumnData.forEach((item, index) => {
      this.mappingConfig[item.id] = {
        'targetField': {
          'id': item.id,
          'title': item.title,
          'type': item.type
        },
        'mappingParts': []
      };
    });
  }
  // 获取下拉列
  getFields(column) {
    this.getAutomationsBoundTypeMapData(column);
    this.getSystemRolesData();
    this.loadMore();
    this.selectedLabels = column.labels || [];
  }
  // 选择列交互
  fieldsChange(column, item) {
    const obj = {
      'id': item.id,
      'type': item.type,
      'title': item.title
    };
    column.mappingValue.push(obj);
    if (column.type === 'status') {
      column.mappingFirstValue = '';
    }
    this.sourceFieldId = item.id;
  }
  roleChange(column, value) {
    if (value) {
      let title = '';
      this.systemRoles.forEach(item => {
        if (item.id === value) {
          title = item.name;
        }
      });
      const obj = {
        id: value,
        type: 'roleField',
        title: title
      };
      column.mappingValue.push(obj);
    }
  }
  userChange(column, value) {
    if (value) {
      let title = '';
      this.systemUsers.forEach(item => {
        if (item.id === value) {
          title = item.name;
        }
      });
      const obj = {
        id: value,
        type: 'userField',
        title: title
      };
      column.mappingValue.push(obj);
    }
  }
  statusChange(column, value) {
    column.mappingFirstValue = value;
    column.mappingValue = [];
  }
  // 删除关联列
  removeFieldTag(column, id) {
    this.boardColumnData.forEach((item, index) => {
      if (isArray(item.mappingValue)) {
        item.mappingValue = item.mappingValue.filter(list => list.id !== id);
      }
    });
  }
  removeFieldItem(column) {
    column.mappingFirstValue = '';
  }
  // 发射表单数据
  onSubmit() {
    this.nfDataChange.emit(this.boardColumnData);
  }
  // 获取系统角色
  getSystemRolesData() {
    const params = {
      page: 1,
      rows: 2000
    };
    this.taskService.getSystemRoles(params).subscribe((res: any) => {
      this.systemRoles = res && res._embedded ? res._embedded.vos : [];
    });
  }
  // 下拉加载更多
  loadMore(): void {
    if (this.loadMoreData) {
      this.randomUserUrl = this.taskService.getBoardUser(this.boardId);
      const param = {
        size: this.pageSize.toString(),
        page: this.pageIndex.toString()
      };
      this.getBoardUserList = this.http
        .get(`${this.randomUserUrl}`, {params: param})
        .pipe(map((res: any) => res))
        .pipe(
          map((list: any) => {
            return list;
          })
        );
      this.isLoading = true;
      this.getBoardUserList.subscribe(data => {
        this.isLoading = false;
        if (data) {
          const newData = data.users && data.users.data ? data.users.data : [];
          this.systemUsers = [...this.systemUsers, ...newData];
          if (this.pageIndex === data.users.page.totalPages) {
            this.loadMoreData = false;
            return;
          }
          this.pageIndex = data.users.page.number + 1;
        }
      });
    }
  }
  // 模糊搜索
  onMemberSearch(value: string): void {
    if (this.firstLoading) {
      this.firstLoading = false;
      return;
    }
    this.isLoading = true;
    this.pageIndex = 1;
    const param = {
      size: this.pageSize.toString(),
      page: this.pageIndex.toString(),
      searchKey: value
    };
    this.taskService.getBoardUer(this.boardData.id, param).subscribe((res: any) => {
      if (res) {
        this.systemUsers = res.users ? res.users.data : [];
        this.loadMoreData = this.pageIndex !== res.users.page.totalPages;
        this.isLoading = false;
      }
    });
  }
}
